import React from "react";

const MScorecardChart = () => <div/>;

export default MScorecardChart;